import axios from "axios";
import {ENDPOINTS, SITE_SEARCH_API_KEY, SITE_SEARCH_AUTHORITY} from "../../js/api/_config";
import moment from "moment";

export class TrinitySearchServices {

    static dateStartConstant = "2001-01-01T10:57:02.444Z"

    static collectionFacetsList = ["Tag", "Categories", "Training_Category", "Training_Industry", "State", "Author_Name", "Product", "Services", "ResourceType", "ModelingCategory"]

    static initialNewSearchStaticData = {
        "count": true,
        "skip": 0,
        "top": 10,
        "searchMode": "any",
        "queryType": "simple",
        "orderby": "",
        "facets": [
            "Article_Tags,count:30,sort:count",
            "Tag,count:30,sort:count",
            "Category,count:30,sort:count",
            "State,count:100,sort:count",
            "Author_Name,count:30,sort:count",
            "Categories,count:30,sort:count",
            "Format,count:30,sort:count",
            "Training_Category,count:30,sort:count",
            "Training_Industry,count:30,sort:count",
            "Product,count:30,sort:count",
            "Services,count:30,sort:count",
            "ResourceType,count:30,sort:count",
            //"IndustryType,count:10,sort:count",
            "ModelingCategory,count:30,sort:count",
            "DatePublished,values:" + TrinitySearchServices.dateStartConstant + "|" + moment().add(1, 'y').toDate().toISOString(),
            // "Type,count:5,sort:count"
        ],
        "filter": "",
        "search": "*"
    };

    static searchForNewsSiteSearch(requestBody) {
        return axios({
            method: 'POST',
            url: ENDPOINTS.TRINITY_SEARCH.SEARCH_FOR_NEWS,
            headers: {
                'api-key': SITE_SEARCH_API_KEY,
                'content-type': "application/json",
                "authority": SITE_SEARCH_AUTHORITY
            },
            data: requestBody
        }).then(e => {
            return e.data;
        }).catch(e => {
            return e.response !== undefined ? "" : "";
        })
    }
}